<template>
  <div id="animation"></div>
</template>
<script>
import lottie from "lottie-web"
export default {
  props: {
    animationData: {
      type: Object
    }
  },
  mounted() {
    lottie.loadAnimation({
      container: document.getElementById("animation"),
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: this.animationData
    })
  }
}
</script>
